import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardHeader,
    CardFooter
} from 'reactstrap';

import { Colxx } from '../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../components/common/react-notifications';
import {
    reactSelectOption,
    reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import topic from '../../../../../data/topic';
import Rules from '../../../../../data/Rules';
import country from '../../../../../data/country';
import Languages from '../../../../../data/languages';
import Select from 'react-select';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
const Device = [
    { value: 'Desktop', label: 'Desktop' },
    { value: 'Mobile', label: 'Mobile' },
];
export function RuleForm({ visible, formLabel, integrationId, ruleId, updatedData, toggle, submit, questionOption }) {
    const [updateRuleData, setUpdateRuleData] = useState([{
        id: undefined,
        ruleName: "",
        condition: [{
            text: "",
            operator: "",
            tags: [],
            recommenderOptions: []
        }]
    }]);
    const [selectedTopic, setSelectedTopic] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState([]);
    const [selectedDevice, setSelectedDevice] = useState([]);
    const [questionOptionsList, setQuestionOptionsList] = useState(questionOption);
    const [selectedQuestionOptions, setSelectedQuestionOptions] = useState([]);
    useEffect(() => {
        if (updatedData !== undefined) {
            updatedData[0].condition.map((item) => {
                if (item.tags && item.tags.length > 0) {
                    if (item.text === "Topic customer had a conversation about") {
                        var top = [];
                        item.tags.map(i =>
                            topic.filter((e) => e.topic === i).map(items =>
                                top.push({
                                    value: items.topic,
                                    label: items.topic
                                })
                            ))
                        setSelectedTopic(top);
                    }
                    else if (item.text === "Customer's country") {
                        var con = [];
                        item.tags.map(i =>
                            country.filter((e) => e.code === i).map(items =>
                                con.push({
                                    value: items.code,
                                    label: items.name
                                })
                            ))
                        setSelectedCountry(con);
                    }
                    else if (item.text === "Customer's preferred language") {
                        var lang = [];
                        item.tags.map(i =>
                            Languages.filter((e) => e.code === i).map(items =>
                                lang.push({
                                    value: items.code,
                                    label: items.name
                                })
                            ))
                        setSelectedLanguage(lang);
                    }
                    else if (item.text === "Customer's device (Desktop, Mobile)") {
                        var devi = [];
                        item.tags.map(i =>
                            Device.filter((e) => e.value === i).map(items =>
                                devi.push({
                                    value: items.value,
                                    label: items.label
                                })
                            ))
                        setSelectedDevice(devi);
                    }
                }
                if (item.recommenderOptions && item.recommenderOptions.length > 0) {
                    if (item.text === "Recommender choices made by the customer") {
                        var opt = [];
                        item.recommenderOptions.map(i =>
                            questionOption.filter((e) => e.value === i.id).map(items =>
                                opt.push({
                                    value: items.value,
                                    label: items.label
                                })
                            ));
                        setSelectedQuestionOptions(opt);
                    }
                }
            });

            setUpdateRuleData(updatedData);
        }
    }, [updatedData]);

    const handleInputData = (e, index, subIndex) => {
        const values = [...updateRuleData];
        if (e.target.name === "rule") {
            values[index].condition[subIndex].text = e.target.value;
            values[index].condition[subIndex].tags = [];
            values[index].condition[subIndex].recommenderOptions = [];
        }
        else if (e.target.name === "operator") {
            values[index].condition[subIndex].operator = e.target.value;
        }
        else if (e.target.name === "name") {
            values[index].ruleName = e.target.value;
        }
        setUpdateRuleData(values);
    };
    const handleChangeSelect = (selectedOptions, index, subIndex, name) => {
        let tags = [];
        let recommender = [];
        if (name === "topic") {
            setSelectedTopic(selectedOptions.value);
            tags = selectedOptions.map((a) => a.value);
        } else if (name === "language") {
            setSelectedLanguage(selectedOptions.value);
            tags = selectedOptions.map((a) => a.value);
        } else if (name === "country") {
            setSelectedCountry(selectedOptions.value);
            tags = selectedOptions.map((a) => a.value);
        } else if (name === "device") {
            setSelectedDevice(selectedOptions.value);
            tags = selectedOptions.map((a) => a.value);
        } else if (name === "options") {
            setSelectedQuestionOptions(selectedOptions.value);
            selectedOptions.map((a) => recommender.push({ id: a.value, title: a.label }));
        }
        const values = [...updateRuleData];
        values[index].condition[subIndex].tags = tags;
        values[index].condition[subIndex].recommenderOptions = recommender;
        setUpdateRuleData(values);
    };
    const handleRemoveCondition = (index, subIndex) => {
        const values = [...updateRuleData];
        values[index].condition.splice(subIndex, 1);
        setUpdateRuleData(values);
    };
    const handleMoreCondition = (e, index) => {
        const values = [...updateRuleData];
        values[index].condition.push({
            text: "",
            operator: "",
            tags: []
        });
        setUpdateRuleData(values);
    };
    const handleSubmit = () => {
        let values = { ...updateRuleData };
        values = values[0];
        let body = {
            ...values,
            groupId: getGroupID(),
            integrationId: integrationId,
        }
        submit(body);
        setToggle();
    };
    const setToggle = () => {
        setUpdateRuleData([{
            id: undefined,
            ruleName: "",
            condition: [{
                text: "",
                operator: "",
                tags: [],
                recommenderOptions: []
            }]
        }]);
        setSelectedTopic([]);
        setSelectedLanguage([]);
        setSelectedDevice([]);
        setSelectedCountry([]);
        toggle(!visible);
    }
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>{formLabel} Rule</ModalHeader>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            {updateRuleData.map((item, index) => (
                                <Fragment key={index}>
                                    <Card style={{ marginBottom: "10px" }}>
                                        <CardBody>
                                            <Row>
                                                <Colxx sm={12} className="mb-6" style={{ marginBottom: "10px" }}>
                                                    <Input
                                                        type="text"
                                                        value={item.ruleName}
                                                        placeholder="Rule Name"
                                                        onChange={(e) => handleInputData(e, index)}
                                                        name="name"
                                                    />
                                                </Colxx>
                                            </Row>
                                            <Row>
                                                {item.condition.map((con, itemIndex) => (
                                                    <Fragment key={itemIndex}>
                                                        {itemIndex !== 0 && (
                                                            <Colxx sm={3} lg={4} className="mb-6" style={{ marginBottom: "10px" }}>
                                                                <Input
                                                                    type="select"
                                                                    value={con.operator}
                                                                    name="operator"
                                                                    onChange={(e) => handleInputData(e, index, itemIndex)}
                                                                >
                                                                    <option value="0">Select</option>
                                                                    <option value="AND">AND</option>
                                                                    <option value="OR">OR</option>
                                                                </Input>
                                                            </Colxx>
                                                        )}
                                                        <Colxx sm={itemIndex === 0 ? 12 : con.tags && con.tags.length === 0 ? 7 : 8} className="mb-6" style={{ marginBottom: "10px" }}>
                                                            <Input
                                                                type="select"
                                                                value={con.text}
                                                                name="rule"
                                                                onChange={(e) => handleInputData(e, index, itemIndex)}
                                                            >
                                                                <option value={0}>Select Condition</option>
                                                                {Rules.map((elem, i) => {
                                                                    return (
                                                                        <option key={i} value={elem.value}>
                                                                            {elem.label}
                                                                        </option>
                                                                    );
                                                                })}
                                                            </Input>
                                                        </Colxx>
                                                        {con.text === "Topic customer had a conversation about" && (
                                                            <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                                <Select
                                                                    isMulti={true}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="topic"
                                                                    options={
                                                                        topic
                                                                            ? reactSelectOptionDiffrentPro(
                                                                                topic,
                                                                                true,
                                                                                'topic',
                                                                                'topic',
                                                                                'All Topics'
                                                                            )
                                                                            : []
                                                                    }
                                                                    placeholder="Topics"
                                                                    value={selectedTopic}
                                                                    onChange={(e) => handleChangeSelect(e, index, itemIndex, "topic")}
                                                                />
                                                            </Colxx>
                                                        )}
                                                        {con.text === "Customer's country" && (
                                                            <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                                <Select
                                                                    isMulti={true}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="country"
                                                                    placeholder="Countries"
                                                                    onChange={(e) => handleChangeSelect(e, index, itemIndex, "country")}
                                                                    options={
                                                                        country
                                                                            ? reactSelectOptionDiffrentPro(
                                                                                country,
                                                                                true,
                                                                                'code',
                                                                                'name',
                                                                                'All Countries'
                                                                            )
                                                                            : []
                                                                    }
                                                                    value={selectedCountry}
                                                                />
                                                            </Colxx>
                                                        )}
                                                        {con.text === "Customer's preferred language" && (
                                                            <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                                <Select
                                                                    isMulti={true}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="language"
                                                                    placeholder="language"
                                                                    onChange={(e) => handleChangeSelect(e, index, itemIndex, "language")}
                                                                    options={
                                                                        Languages
                                                                            ? reactSelectOptionDiffrentPro(
                                                                                Languages,
                                                                                true,
                                                                                'code',
                                                                                'name',
                                                                                'All Language'
                                                                            )
                                                                            : []
                                                                    }
                                                                    value={selectedLanguage}
                                                                />
                                                            </Colxx>
                                                        )}
                                                        {con.text === "Customer's device (Desktop, Mobile)" && (
                                                            <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                                <Select
                                                                    isMulti={true}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="device"
                                                                    placeholder="device"
                                                                    onChange={(e) => handleChangeSelect(e, index, itemIndex, "device")}
                                                                    options={
                                                                        Device
                                                                            ? reactSelectOptionDiffrentPro(
                                                                                Device,
                                                                                true,
                                                                                'label',
                                                                                'value',
                                                                                'All Device'
                                                                            )
                                                                            : []
                                                                    }
                                                                    value={selectedDevice}
                                                                />
                                                            </Colxx>
                                                        )}
                                                        {con.text === "Recommender choices made by the customer" && (
                                                            <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                                <Select
                                                                    isMulti={true}
                                                                    className="react-select"
                                                                    classNamePrefix="react-select"
                                                                    name="options"
                                                                    placeholder="options"
                                                                    onChange={(e) => handleChangeSelect(e, index, itemIndex, "options")}
                                                                    options={
                                                                        questionOptionsList
                                                                            ? reactSelectOptionDiffrentPro(
                                                                                questionOptionsList,
                                                                                true,
                                                                                'value',
                                                                                'label',
                                                                                'All Options'
                                                                            )
                                                                            : []
                                                                    }
                                                                    value={selectedQuestionOptions}
                                                                />
                                                            </Colxx>
                                                        )}

                                                        {itemIndex !== 0 && (
                                                            <Fragment>
                                                                <Colxx sm={1} className="mb-6">
                                                                    <Button
                                                                        onClick={() =>
                                                                            handleRemoveCondition(index, itemIndex)
                                                                        }
                                                                        color="secondary"
                                                                        size="xs"
                                                                        outline
                                                                        style={{ margin: '6px' }}
                                                                    >
                                                                        -
                                                                    </Button>
                                                                </Colxx>
                                                            </Fragment>
                                                        )}
                                                    </Fragment>
                                                ))}
                                                <Colxx sm={6} className="mb-6">
                                                    <Button
                                                        onClick={(e) => handleMoreCondition(e, index)}
                                                        color="secondary"
                                                        size="sm"
                                                        outline
                                                        style={{ margin: '6px' }}
                                                    >
                                                        + Condition
                                                    </Button>
                                                </Colxx>
                                            </Row>
                                        </CardBody>
                                    </Card>

                                </Fragment>
                            ))}
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                        onClick={handleSubmit}
                    >
                        {formLabel}
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );

};